import { render, staticRenderFns } from "./Statistics.view.vue?vue&type=template&id=1be8042e&scoped=true"
import script from "./Statistics.view.vue?vue&type=script&lang=ts"
export * from "./Statistics.view.vue?vue&type=script&lang=ts"
import style0 from "./Statistics.view.vue?vue&type=style&index=0&id=1be8042e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8042e",
  null
  
)

export default component.exports